module.exports = __webpack_public_path__ + "img/WEB-BOT-EROVET.5191aed1.png";